import { Tag } from 'antd';

export default function MatchRateBadge({ rate }) {
  if (rate == null) return null;

  let color = 'red';
  if (rate >= 99) color = 'green';
  else if (rate >= 95) color = 'orange';

  return <Tag color={color}>{rate}%</Tag>;
}
